<template>
    <div class="flex justify-content-between mx-5 my-3">
        <h2 class="text-secondary">Sincronizzazione</h2>
        <Button label="NEW" icon="pi pi-plus" @click="nuovaSync()" class="p-button-primary w-1" />
    </div>
    <div>
        <div v-if="loading" class="col-12 h-30rem flex justify-content-center align-items-center">
            <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="transparent"
                animationDuration=".5s" aria-label="Custom ProgressSpinner" />
        </div>
        
        <DataTable v-if="!loading" :value="logs" paginator :rows="30" showGridlines class="file-table">
            <Column field="group_id" header="Gruppo" style="width: 10%"></Column>
            <Column field="tabelle" header="N.Tabelle" style="width: 10%"></Column>
            <Column field="data_inizio" header="Data Inizio" style="width: 15%"></Column>
            <Column field="data_fine" header="Data Fine" style="width: 15%"></Column>
            <Column field="errore" header="Errore">
                <template #body="slotProps">
                    <button v-if="slotProps.data.errore == '1'" @click="showErrorMessage(slotProps.data.err_msg)" class="p-button p-button-rounded p-button-outlined" style="color:red;">
                        <i class="pi pi-times-circle"></i>
                    </button>
                    <i v-else class="pi pi-check-circle px-3 py-2" style="color: green;"></i>
                </template>
            </Column>
            <Column field="azioni" header="Azioni" style="min-width: 8rem">
                <template #body="slotProps">
                    <button @click="config(slotProps.data)" class="p-button p-button-text">
                        <i class="pi pi-cog mr-1" style="color:black"></i> Configurazioni
                    </button>

                    <button @click="viewLogs(slotProps.data)" class="p-button p-button-text">
                        <i class="pi pi-eye mr-1" style="color:black"></i> Vedi logs
                    </button>

                    <button @click="deleteGroupConfirm(slotProps.data.group_id)" class="p-button p-button-text" style="color:red">
                        <i class="pi pi-trash mr-1" style="color:red"></i> Elimina
                    </button>
                </template>
            </Column>
        </DataTable>
    </div>

    <Dialog v-model:visible="error_message" modal header="Errore" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <p class="m-0">
            {{ error_text }}
        </p>
    </Dialog>

    <template>
        <div>
            <Dialog :visible="isDialogVisible" @hide="isDialogVisible = false" header="Modifica" :closable="false" :style="{ width: '50rem' }">

                <span class="text-surface-500 dark:text-surface-400 block mb-8">Aggiorna record con ID: {{ selectedItem.id }}</span>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Database Sorgente</label>
                    <dropdown id="src" class="flex-1 p-inputtext p-component" v-model="selectedItem.source_db_id" :options="db" optionLabel="dbname" placeholder="Scegli Database..." />
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Database Destinatario</label>
                    <dropdown id="src" class="flex-1 p-inputtext p-component" v-model="selectedItem.destination_db_id" :options="db" optionLabel="dbname" placeholder="Scegli Database..." />
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Tabella</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.table_name"/>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Metodo</label>
                    <select id="src" class="flex-1 p-inputtext p-component" v-model="selectedItem.type">
                        <option value="sync">Sync</option>
                        <option value="append">Append</option>
                        <option value="delete">Delete</option>
                        <option value="pendv2">Append V.2</option>
                        <option value="move">Move</option>
                    </select>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Gruppo</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.group_id"/>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Order ID</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.orderID"/>
                </div>
                <div class="flex justify-content-end align-items-center gap-x-4 my-4" style="gap: 5px">
                    <button @click="isDialogVisible = false" class="p-button p-button-text">Chiudi</button>
                    <button @click="salvaModifiche(selectedItem)" class="p-button p-button-text">Salva</button>
                </div>
            </Dialog>
        </div>
    </template>
</template>

<script>
    import { ref, computed, getCurrentInstance, onMounted } from "vue";
    import SyncService from "../../../services/ask-database-sync/database-sync";
    import router from '@/router'
    import ProgressSpinner from 'primevue/progressspinner';
    import Dropdown from 'primevue/dropdown'
    import { useConfirm } from "primevue/useconfirm";

    export default {
        components: {
            ProgressSpinner,
            Dropdown
        },
        setup() {
            const instance = getCurrentInstance();
            const eventBus = instance.appContext.config.globalProperties.$eventBus;
            const logs = ref([]);
            const sync_logs = ref([]);
            const sync_logs_group_date = ref([]);
            const loading = ref(true);
            const error_message = ref(false);
            let error_text = ref('');
            const isDialogVisible = ref(false);
            const selectedItem = ref(null);
            const db = ref([]);
            const confirm = useConfirm();

            const service = new SyncService(eventBus);

            const init = () => {
                service.getSyncLogs().then((syncData) => {
                    sync_logs.value = syncData;
    
                    service.getSyncGroupDate().then((syncGroupData) => {
                        sync_logs_group_date.value = syncGroupData;
    
                        joinData(sync_logs.value, sync_logs_group_date.value);
                    });
                });
            }
            init();

            service.getDatabaseDetails().then(data => {
                db.value = data;
            });

            const joinData = (arr1, arr2) => {
                logs.value.length = 0;
                arr1.forEach(element => {
                    const groupId = element.group_id;
                    const filteredData = arr2.filter(item => item.group_id == groupId);
                    console.log("filteredData", filteredData);

                    let result = null;
                    if (filteredData.length > 0) {
                        result = filteredData.reduce((max, item) =>
                            Number(item.id) > Number(max.id) ? item : max,
                            filteredData[0]
                        );
                    }

                    console.log("result", result);

                    if (result) {
                        element = {
                            ...element,
                            ...result
                        };
                    }

                    logs.value.push(element);
                });

                loading.value = false;
            };   

            const viewLogs = (item) => {
                router.push({name: 'databaseSyncLogsGroup', params: {group_id: item.group_id}});
            };

            const config = (item) => {
                router.push({name: 'databaseSync', params: {group_id: item.group_id}});
            };

            const showErrorMessage = (err_msg) => {
                error_message.value = true;
                error_text.value = err_msg;
            }

            const nuovaSync = () => {
                selectedItem.value = {
                    "id": null,
                    "table_name": "",
                    "source_db_id": 0,
                    "destination_db_id": 0,
                    "type": "delete",
                    "group_id": 0,
                    "orderID": null
                }
                isDialogVisible.value = true;
            }

            const salvaModifiche = (itemUpdated) => {
                service.saveSyncTable(itemUpdated).then(() => {
                    isDialogVisible.value = false;
                    init();
                });
            }

            const deleteGroup = (group_id) => {
                service.eliminaGruppo(group_id);
                init();
            }

            const deleteGroupConfirm = (group_id) => {
                confirm.require({
                    message: `Sei sicuro di voler eliminare il gruppo ${group_id}?`,
                    header: 'Eliminazione',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        deleteGroup(group_id);
                    },
                    reject: () => {
                        console.log("Eliminazione annullata");
                    }
                });
            }

            return {
                logs,
                viewLogs,
                loading,
                config,
                showErrorMessage,
                error_message,
                error_text,
                nuovaSync,
                selectedItem,
                isDialogVisible,
                db,
                salvaModifiche,
                init,
                deleteGroup,
                deleteGroupConfirm
            }
        }
    }
</script>

<style scoped>
</style>